import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Table from 'src/components/Table';
import TableCell from 'src/components/Table/TableCell';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';
import AgentsRow from './AgentsRow';

const AgentsTable = ({ className, agents, ...rest }) => {
  const { t } = useTranslation();
  const theads = useMemo(() => () => (
    <TableRow>
      <TableCell>{t('COMMON.NAME')}</TableCell>
      <TableCell>{t('COMMON.CITY')}</TableCell>
    </TableRow>
  ));

  const tbody = useMemo(
    () => () => {
      return agents.map(agent => <AgentsRow {...agent} key={agent.taxId} />);
    },
    [agents]
  );

  return <Table tbody={tbody} theads={theads} {...rest} />;
};

AgentsTable.propTypes = {
  className: PropTypes.string,
  agents: PropTypes.array.isRequired
};

export default AgentsTable;
